import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
  overlay,
  modal,
  closeBtn,
  leftArrow,
  rightArrow,
  image,
  dotsContainer,
  dot,
  active,
  titleStyle,
  contentStyle,
  slideContent,
  navigation,
  anchor,
} from './style.module.scss';
import Gateway from 'src/img/wifiTipsAndTricks/move-closer-to-gateway.gif';
import Cleargateway from 'src/img/wifiTipsAndTricks/clear_way.png';
import Restartgateway from 'src/img/wifiTipsAndTricks/restart_gateway.png';
import Relocategateway from 'src/img/wifiTipsAndTricks/relocate_gateway.png';
import Troubleshooting from 'src/img/wifiTipsAndTricks/troubleshooting_tool.png';
import CloseButton from 'src/img/wifiTipsAndTricks/close_button.png';
import DesktopArrowLeft from 'src/img/wifiTipsAndTricks/desktop_arrow_left.png';
import DesktopArrowRight from 'src/img/wifiTipsAndTricks/desktop_arrow_right.png';
import MobileArrowLeft from 'src/img/wifiTipsAndTricks/mobile_caret_left.png';
import MobileArrowRight from 'src/img/wifiTipsAndTricks/mobile_caret_right.png';
import {chat} from '../../../contactUs/components/Chat/propTypes';

const LinkIcon = <svg width="1em" height="1em" viewBox="0 0 15 15" focusable="false" className="w-20 h-20 ml-2 fill-current"><title></title><defs><path d="M16.429 7.898c-.008-.022-.013-.046-.022-.067a.779.779 0 00-.169-.266l-1.964-2.034a.737.737 0 00-1.068 0 .826.826 0 000 1.125l.713.758H7.241c-.406 0-.736.368-.736.788 0 .421.33.79.736.79h6.777l-.775.754a.77.77 0 000 1.08.737.737 0 001.067-.012l1.966-2.04a.81.81 0 00.153-.876zm-6.684 2.474c-.406 0-.666.342-.666.762v2.02c0 .477-.31.966-.771.966H2.984c-.46 0-.955-.489-.955-.966V3.578c0-.477.495-.698.955-.698h5.324c.46 0 .77.221.77.698v2.02c0 .42.261.762.667.762.407 0 .667-.341.667-.762v-2.02c0-1.316-.832-2.275-2.104-2.275H2.984c-1.272 0-2.479.959-2.479 2.275v9.577c0 1.315 1.207 2.542 2.479 2.542h5.324c1.272 0 2.104-1.227 2.104-2.543v-2.02c0-.42-.26-.762-.667-.762z" id="ExternalLink_svg__a" stroke="none" strokeWidth="1" fillRule="evenodd"></path></defs><use xlinkHref="#ExternalLink_svg__a"></use></svg>;

export const getImage = (imageName = '') => {
  const formattedImageName = imageName.toLowerCase();
  switch (formattedImageName) {
    case 'gateway':
      return Gateway;
    case 'cleargateway':
      return Cleargateway;
    case 'relocategateway':
      return Relocategateway;
    case 'restartgateway':
      return Restartgateway;
    case 'troubleshooting':
      return Troubleshooting;
    default:
      return '';
  }
};

export const ModalCarousel = ({slides, onCloseModal, launchXfinityAssistant}) => {
  const [onMobile, setOnMobile] = useState(false);
  useEffect(() => {
    setOnMobile(window.matchMedia('(max-width: 664px)').matches);
  }, []);

  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  const chatWithXALink = (
    <button
      className={anchor}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => launchXfinityAssistant('skill.xfi.internet.troubleshoot')}
      href="https://www.xfinity.com/xfinityassistant/"
    >
      Give it a try {LinkIcon}
    </button>
  );

  return (
    <>
      <div className={overlay} />
      <div className={modal}>
        <button className={closeBtn} onClick={onCloseModal} onKeyDown={onCloseModal}>
          <img src={CloseButton} alt="Close Button" />
        </button>
        {slides.map((slide, index) => (
          <div key={index}>
            {index === current && (
              <div key={index} className={slideContent}>
                <div>
                  <img src={getImage(slide.image)} alt={slide.image} className={image} />
                </div>
                <div>
                  <div className={titleStyle}>{slide.title}</div>
                  <div className={contentStyle}>{slide.content}</div>
                  {slide.image.toLowerCase() === 'troubleshooting' && chatWithXALink}
                </div>
              </div>
            )}
          </div>
        ))}
        <div className={navigation}>
          {onMobile ?
            <>
              <button className={leftArrow} onClick={prevSlide}>
                <img src={MobileArrowLeft} alt="Left Arrow" />
              </button>
              <button className={rightArrow} onClick={nextSlide}>
                <img src={MobileArrowRight} alt="Right Arrow" />
              </button>
            </> :
            <>
              <button className={leftArrow} onClick={prevSlide}>
                <img src={DesktopArrowLeft} alt="Left Arrow" />
              </button>
              <button className={rightArrow} onClick={nextSlide}>
                <img src={DesktopArrowRight} alt="Right Arrow" />
              </button>
            </>
          }

          <div className={dotsContainer}>
            {slides.map((_, index) => (
              <button
                key={index}
                className={`${index === current ? active : dot}`}
                onClick={() => setCurrent(index)}
                aria-label="navigation dots"
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

ModalCarousel.propTypes = {
  slides: PropTypes.array,
  onCloseModal: PropTypes.func,
  launchXfinityAssistant: chat.launchXfinityAssistant,
};
